import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Button, Spinner } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSearch, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from 'react-cookie'
import { Context } from '../TransactionHistory'
import { exportAllMoneyLog } from '../../../../controller/api/moneyLog'
import { exportTransactionHistoryToExcel } from '../../../../helpers/excelExport'
import { WALLET_OPTIONS } from '../../../../helper/wallet'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);
  const _wallet = useRef(state.filter.wallet);

  const [isExporting, setIsExporting] = useState(false);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeWallet = useCallback((payload) => {
    _wallet.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current,
        wallet: _wallet.current
      }
    })
  }, [dispatch])

  const handleExportExcel = async () => {
    setIsExporting(true)
    try {
      const response = await exportAllMoneyLog(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
        phone: state.filter.phone,
        wallet: state.filter.wallet
      })

      if (response && response.data) {
        if (response.data.length === 0) {
          alert('Không có dữ liệu để xuất')
          return
        }
        exportTransactionHistoryToExcel(response.data, state.filter)
      }
    } catch (error) {
      console.error('Export failed:', error)
      alert('Xuất Excel thất bại. Vui lòng thử lại!')
    } finally {
      setIsExporting(false)
    }
  }

  const renderDateInput = (valueRef) => (props, openCalendar) => (
    <InputGroup className="input-group-merge">
      <InputGroup.Text className="bg-white border-end-0">
        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
      </InputGroup.Text>
      <Form.Control
        type="text"
        className="border-start-0 ps-0"
        value={valueRef.current ? moment(valueRef.current).format("DD/MM/YYYY") : ""}
        placeholder="dd/mm/yyyy"
        onFocus={openCalendar}
        onChange={() => { }}
      />
    </InputGroup>
  )

  return (
    <Card border="light" className="shadow-sm border-0">
      <Card.Body className="p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="mb-0 text-primary fw-bold">
            <FontAwesomeIcon icon={faFilter} className="me-2" />
            Lịch sử giao dịch ví
          </h5>
        </div>

        <Row className="g-3 align-items-end">
          <Col xs={12} md={6} xl={3}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
            <Datetime
              timeFormat={false}
              closeOnSelect={true}
              onChange={_handleChangeFrom}
              renderInput={renderDateInput(_from)}
            />
          </Col>

          <Col xs={12} md={6} xl={3}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
            <Datetime
              timeFormat={false}
              closeOnSelect={true}
              onChange={_handleChangeTo}
              renderInput={renderDateInput(_to)}
            />
          </Col>

          <Col xs={12} md={6} xl={3}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Số điện thoại</Form.Label>
            <Form.Control
              type="text"
              defaultValue={state.filter.phone}
              placeholder="Nhập số điện thoại"
              className="bg-white"
              onChange={_handleChangePhone}
              onKeyDown={(e) => {
                if (e.key === "Enter") _submitForm()
              }}
            />
          </Col>

          <Col xs={12} md={6} xl={3}>
            <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Loại ví</Form.Label>
            <Form.Select defaultValue={state.filter.wallet} onChange={_handleChangeWallet}>
              {WALLET_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs={12} className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              className="shadow-sm"
              disabled={state.loading}
              onClick={_submitForm}
            >
              {state.loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang tải...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} className="me-2" />
                  Tìm kiếm
                </>
              )}
            </Button>
            <Button
              variant="success"
              type="button"
              className="shadow-sm"
              disabled={isExporting || state.loading}
              onClick={handleExportExcel}
            >
              {isExporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang xuất...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                  Xuất Excel
                </>
              )}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm)
